import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';

@Component({
  tag: 'send-button',
  shadow: false,
  /*   styleUrl: 'send-button.css', */
})
export class SendButton {
  @Prop() name: string;
  @Prop() label: string;

  @Event() sendButtonClick: EventEmitter;

  sendButtonClickHandler(event: MouseEvent) {
    this.sendButtonClick.emit(event);
    console.log('sendButtonClickHandler', event);
  }

  render() {
    return (
      <div class="d-grid gap-2 d-md-flex justify-content-md-center mx-1">
        <button type="button" class="btn btn-primary text-white" data-bs-toggle="modal" data-bs-target="#staticBackdrop" onClick={event => this.sendButtonClickHandler(event)}>
          <i class="bi bi-check-circle-fill me-2"></i>
          {this.label}
        </button>
      </div>
    );
  }
}
